import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import AccessDeniedCard from './AccessDeniedCard';

interface StaffRouteProps {
  children: React.ReactNode;
}

function normalizeRole(raw: string | undefined | null): string | null {
  if (!raw) return null;
  return raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();
}

// Routes accessible to Bespoke staff (Admin) + tenant staff (Manager, Corporate).
// For Admin-only pages (e.g., the Permissions matrix) use AdminRoute instead.
// Corporate is treated identically to Manager for access decisions.
const StaffRoute: React.FC<StaffRouteProps> = ({ children }) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-cream flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-coral mx-auto"></div>
          <p className="mt-4 text-inkMuted">Loading…</p>
        </div>
      </div>
    );
  }

  if (!user || !user.isAuthenticated) {
    return <Navigate to="/scorecard-login" replace />;
  }

  const role = normalizeRole(user.managementUser?.role);
  if (role !== 'Admin' && role !== 'Manager' && role !== 'Corporate') {
    // feat-324: shared card — the denial (Variant B) or, when the role lookup
    // FAILED, "We couldn't load your account" (Variant A). Both offer Sign out.
    return <AccessDeniedCard message="This page is only available to Bespoke staff and tenant managers." />;
  }

  return <>{children}</>;
};

export default StaffRoute;
